import React, { useState, useRef, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import ContainerCard from "./containerCard";
import SectionHeading from "./sectionHeading";
import { useGlobalContext } from "../../utils/globalContext";
import { Button } from "@speedoc/design-assets";
import { Remarkable } from "remarkable";
import { trackCustom } from "../../services/analytics";
import { GlobalStore } from "../../stores/global";
import { LazyLoadImage } from "react-lazy-load-image-component";

const handleButtonClick = countryCode => {
  trackCustom("Contact", countryCode);
};

const ConditionCardsDesktop = ({ content }) => {
  const { Trans } = useGlobalContext();
  const markdown = new Remarkable();
  const [isOpen, setIsOpen] = useState(undefined);
  const [isOpening, setIsOpening] = useState(undefined);
  const [fractions, setFractions] = useState(undefined);

  useEffect(() => {
    if (content.length === 6) return setFractions(3);
    if (content.length === 8) return setFractions(4);
    setFractions(5);
  }, [content]);

  const openCard = index => {
    setIsOpen(index);
    startOpening(index);
  };

  const closeCard = index => {
    setIsOpening(undefined);
    setIsOpen(undefined);
  };

  const startOpening = index => {
    setTimeout(() => {
      setIsOpening(index);
    }, 50);
  };

  return (
    <div className={`conditionCardsDesktop grid-${fractions}`}>
      {content.map((card, index) => (
        <div className="card" key={index} onMouseEnter={() => openCard(index)} onMouseLeave={() => closeCard(index)}>
          <LazyLoadImage src={card.image.url} alt="" style={{ zIndex: isOpening === index ? 50 : 0 }} effect="blur" />
          <div className="closed-card">
            <ContainerCard
              key={index}
              style={{
                boxShadow: isOpening === index && "",
                backgroundColor: isOpen === index && "#F3F3F3"
              }}>
              <div className="cardTitle">
                <p className="title">
                  <Trans>{card.title}</Trans>
                </p>
              </div>
            </ContainerCard>
          </div>
          {isOpen === index && (
            <div className={`opened-card ${isOpening === index ? "opening" : ""}`}>
              <ContainerCard key={index}>
                <div className="cardTitle">
                  <p className="title">
                    <Trans>{card.title}</Trans>
                  </p>
                </div>
                <div className="cardContent">
                  <div className="content" dangerouslySetInnerHTML={{ __html: markdown.render(card.content) }} />
                </div>
              </ContainerCard>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const ConditionCardsMobile = ({ content, cross }) => {
  const { Trans } = useGlobalContext();
  const markdown = new Remarkable();
  const wrapperRef = useRef(null);
  const [isOpen, setIsOpen] = useState(undefined);

  useEffect(() => {
    const handleClickOutside = event => {
      if (isOpen !== undefined && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(undefined);
      }
    };
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, [isOpen]);

  const toggleModal = index => {
    isOpen === index ? setIsOpen(undefined) : setIsOpen(index);
  };

  return (
    <div className="conditionCardsMobile">
      {content.map((card, index) => (
        <div key={index}>
          <div className="card" onClick={() => toggleModal(index)}>
            <LazyLoadImage src={card.image?.url} alt="" effect="blur" />

            <div className="closed-card">
              <ContainerCard key={index}>
                <div className="cardTitle">
                  <p className="title">
                    <Trans>{card.title}</Trans>
                  </p>
                </div>
              </ContainerCard>
            </div>
          </div>
          {isOpen === index && (
            <div className="modal">
              <div id="open-card" ref={wrapperRef}>
                <ContainerCard key={index}>
                  <span className="close" onClick={() => toggleModal(index)}>
                    <img src="//public.speedoc.com/strapi/Cross_327c1b7966.svg" alt="close" />
                  </span>
                  <div className="cardTitle">
                    <LazyLoadImage src={card.image?.url} alt="" effect="blur" />
                    <p className="title">
                      <Trans>{card.title}</Trans>
                    </p>
                  </div>
                  <div className="cardContent">
                    <div className="content" dangerouslySetInnerHTML={{ __html: markdown.render(card.content) }} />
                  </div>
                </ContainerCard>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

const ConditionCards = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });
  const {
    currentCountryCode: countryCode,
    currentCountry: { phoneNumberLink }
  } = GlobalStore.useState(c => c);

  return (
    <div className="conditionCards">
      {!!content.captionTop && content.caption && <div className="caption">{content.caption}</div>}
      {content.title && <SectionHeading title={content.title} />}
      {!!content.captionTop && content.information && <div className="information">{content.information}</div>}
      {isMobile ? <ConditionCardsMobile content={content.cards} /> : <ConditionCardsDesktop content={content.cards} />}
      {!content.captionTop && content.caption && <div className="caption">{content.caption}</div>}
      {!content.captionTop && content.information && <div className="information">{content.information}</div>}
      {content.cta && (
        <a href={phoneNumberLink}>
          <Button type="button" className="secondary sm" onClick={e => handleButtonClick(countryCode)}>
            <span>{content.cta}</span>
          </Button>
        </a>
      )}
    </div>
  );
};

export default ConditionCards;
